import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { DmpLogo } from '../../brand/DmpLogo';
import { BdFlag } from '../../brand/BdFlag';
import type { OwnerNav } from '../../../types/owner';
export function OwnerSplash({
  nav
}: {
  nav: OwnerNav;
}) {
  const {
    reset
  } = nav;
  useEffect(() => {
    const t = window.setTimeout(() => reset('onboarding'), 2600);
    return () => window.clearTimeout(t);
  }, [reset]);
  return <button onClick={() => nav.reset('onboarding')} className="flex h-full w-full flex-col items-center bg-white px-8 text-center" aria-label="চালিয়ে যান" data-id="element-1970" data-mp="6pc0dq4qwjfg">
      <div className="flex w-full justify-end pt-3" data-id="element-1971" data-mp="gfdlqa5prnqo">
        <BdFlag width={26} data-id="element-1972" data-mp="ggylqfasryvx" />
      </div>
      <motion.div initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.4
    }} className="flex flex-1 flex-col items-center justify-center" data-id="element-1973" data-mp="bnlv5zmk5i0j">
        <DmpLogo size={120} data-id="element-1974" data-mp="3f4vq4f67jjpr" />
        <p className="mt-6 font-heading text-xl font-bold text-navy-800" data-id="element-1975" data-mp="3f5nn9ufgdpi5">ঢাকা মেট্রোপলিটন পুলিশ</p>
        <div className="my-4 h-0.5 w-12 bg-bdgreen-600" data-id="element-1976" data-mp="4o2w2ojce3v1" />
        <p className="font-heading text-2xl font-bold text-navy-900" data-id="element-1977" data-mp="4lgo4nsjhmca">ডিএমপি গাড়ির মালিক সেবা</p>
        <p className="mt-1 text-base text-slate-600" data-id="element-1978" data-mp="8ms7wcoqfdck">যানবাহনের তথ্য নিবন্ধন ও যাচাই</p>
        <div className="mt-8 flex items-center gap-2 text-xs text-slate-400" data-id="element-1979" data-mp="dgd3xz6rlx94">
          <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-bdgreen-600" data-id="element-1980" data-mp="idd3dr9401r9" />
          লোড হচ্ছে…
        </div>
      </motion.div>
      <div className="w-full border-t border-border pb-8 pt-4" data-id="element-1981" data-mp="3hw5zeajhrza5">
        <p className="text-sm font-semibold text-navy-800" data-id="element-1982" data-mp="3lvww0uvp99ml">ট্রাফিক বিভাগ, ডিএমপি</p>
        <p className="mt-1 font-mono text-[10px] text-slate-400" data-id="element-1983" data-mp="3qtg7xo4xdabd">সংস্করণ ১.০.০ • নাগরিক সেবা</p>
      </div>
    </button>;
}